export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/decc719ac0c1523cc2040d71b927dcbc.svg";